module.exports = __webpack_public_path__ + "img/Google-Cloud.e72ebee3.png";